import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../assets/images/layouts/gmgnsitebanner.webp'
import img2 from '../../assets/images/icon/icon-01.png'
import img3 from '../../assets/images/layouts/avt-01.png'


function Banner(props) {
    return (
        <section className="banner">
                <div className="shape right"></div>
                <div className="container big">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div className="banner__left">
                                <div className="block-text">
                                    <h2 className="heading">Trade Fast <br />
                                        with <span className="s1 arlo_tm_animation_text_word">GMGN</span> <br />
                                        </h2>
                                    <p className="desc">GMGN's Sniper feature enables immediate token purchases at launch, while Auto Sell allows for preset conditions to automate token sales</p>

                                    <a href="https://gmgn.ai/?ref=09Pp1DwR" className="action-btn"><span>Trade Now</span></a>
                                </div>

                                
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">

                            <div className="banner__right">
                                <div className="image">
                                    <img src={img1} alt="GMGN" />
                                </div>

                                {/* <div className="price">
                                    <div className="icon">
                                        <img src={img2} alt="GMGN" />
                                    </div>
                                    <div className="content">
                                        <h5>$Ogchillguy</h5>
                                        <p>MC: $203k - <span className='mkcap'>$5.5M</span> </p>
                                        <div className='profit'>
                                            22X
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className="owner">
                                    <div className="image">
                                        <img src={img3} alt="GMGN" />
                                    </div>
                                    <div className="content">
                                        <h5>$KIKI</h5>
                                        <p>MC: $220k - <span className='mkcap'>$105.7M</span> </p>
                                        <div className='profit'>
                                            431X
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Banner;